import type { ButtonHTMLAttributes } from 'react';

type Variant = 'primary' | 'ghost' | 'soft' | 'danger-soft';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
}

/** One brand-filled primary per screen (Hick's Law). All variants read tokens. */
export function Button({
  variant = 'primary',
  className,
  children,
  ...rest
}: ButtonProps): JSX.Element {
  const cls = ['btn', `btn-${variant}`, className].filter(Boolean).join(' ');
  return (
    <button className={cls} {...rest}>
      {children}
    </button>
  );
}
